import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/DailyDemand',
    baseurl2:'/api/swyl/v1',

    //目标列表
    page(query){
        return http({
            url: this.baseurl+'/userDailyDemand/newSelectPage',
            method: 'post',
            params: query
        });
    },
    reportPage(query){
        return http({
            url: this.baseurl+'/userDailyDemand/selectReportPage',
            method: 'post',
            params: query
        });
    },
    selectAllQuyu(){
        return http({
            url: this.baseurl+'/userDailyDemand/selectAllQuyu',
            method: 'post',
        });
    },
    selectReportTitles(query){
        return http({
            url: this.baseurl+'/userDailyDemand/selectReportTitles',
            method: 'post',
            params: query
        });
    },

    getWeekList(query){
        return http({
            url: this.baseurl+'/userDailyTarget/getWeekList',
            method: 'post',
            params: query
        });
    },
    saveOrUpdate(query){
        return http({
            url: this.baseurl+'/userDailyTarget/saveOrUpdate',
            method: 'post',
            params: query
        });
    },
    selectById(query){
        return http({
            url: this.baseurl+'/userDailyTarget/selectById',
            method: 'post',
            params: query
        });
    },
    del(query){
        return http({
            url: this.baseurl+'/userDailyTarget/deleteById',
            method: 'post',
            params: query
        });
    },
    getPjList(query){
        return http({
            url: this.baseurl+'/userDailyDemand/getPjList',
            method: 'post',
            params: query
        });
    },
    //批量导出
    downloadBatchExcel(query) {
        return http({
            url: '/api/swyl/v1/riqing/userDailyEval/downloadExcel',
            method: 'post',
            data: query,
            responseType: 'blob',
        });
    },

}
